export function isSlideButtonEnabled(_state) {
    return true;
}
